export default {
  data() {
    return {
      //是否自动连接AI助手
      $autoAccessAI: true
    };
  },
  computed: {
    autoAccessAI: {
      get() {
        return this.$data.$autoAccessAI;
      },
      set(v) {
        this.$data.$autoAccessAI = v;
      }
    }
  },
  mounted() {
    this.$parent && this.$initAI();
  },
  // 多页签激活
  multiPageActivated() {
    this.$ai.$setActive(true);
  },
  // 多页签失活
  multiPageDeactivated() {
    this.$ai.$setActive(false);
  },
  methods: {
    $initAI(isMobile) {
      //如果从路由进入页面
      let isDialog = false;
      let islinkAI = this._isRouterEnter;
      if (!islinkAI) {
        //判断页面是否是弹层打开，切弹层中使用ViewPart组件直接加载页面
        const viewPartKey = isMobile ? "DsfMobileViewPart" : "DsfViewPart";
        if (this.$parent.$options.name == viewPartKey) {
          isDialog = islinkAI = this.$parent.isOpenDialog;
        }
      }
      if (islinkAI && this.autoAccessAI) {
        const instance = this._dsfAI_;
        if (dsf.isUnDef(instance)) {
          return;
        }
        if (!this.__connect__) {
          this.__connect__ = instance.open(this);
        }
        this.$AIEventWatch(isDialog);
      }
    },
    $AIEventWatch(isDialog) {
      if (this.$ai) {
        if (isDialog || !dsf.isMultiPage()) {
          this.$ai.$setActive(true);
        } else {
          let isActive = this.$multiView?.init || false;
          isActive && this.$ai.$setActive(true);
        }
        /**** 默认添加ai监听事件 *****/
        if (this.$getAiPromptContext) {
          this.$ai.$on("question", this.$getAiPromptContext);
        }
        if (this.$getAiAnswerHandler) {
          this.$ai.$on("answer", this.$getAiAnswerHandler);
        }
      }
    }
  }
};
